import styled from "styled-components";

export const StyledConfirmContent = styled.div`
    font-family: ${({ theme }) => theme.fontFamily};
    color: ${({ theme }) => theme.color.supportGraphite500};
    font-size: 1.6rem;
    line-height: 1.4;
`;
